/* KC Video Reviews Carousel — logique carrousel + lecture vidéo
 *
 * 2026-08-13 — Correction « les vidéos ne se lancent pas sur mobile ».
 * Avant, un échec de lecture était avalé en silence (`p.catch(function(){})`)
 * et la vidéo restait invisible (opacity 0 tant que `is-ready` n'était pas posé).
 * Résultat sur un téléphone : une case noire, aucun message, aucune piste.
 *
 * 2026-09-08 — Correction « La vidéo n'a pas pu être chargée. Vérifiez votre
 * connexion. » (signalée par Russel). Trois faux positifs corrigés :
 *   1. `stalled` est un évènement NORMAL de mise en mémoire tampon, pas une
 *      panne : il déclenchait le message dès que le réseau ralentissait.
 *   2. L'erreur sur la 1re <source> (le flux m3u8, ignoré par Chrome/Firefox)
 *      était traitée comme une panne alors que le navigateur passe simplement
 *      au MP4 suivant. Seul `video.error` (toutes les sources épuisées) compte.
 *   3. Le délai de sécurité passe de 12 à 25 s et, s'il expire, on donne le
 *      lecteur natif (nouvel essai possible) au lieu d'un message sans issue.
 *
 * Ce que ce fichier garantit maintenant :
 *   - toute panne de lecture est visible (retour sur l'image de couverture + message)
 *   - si le navigateur refuse la lecture automatique, on affiche le lecteur natif
 *     au lieu d'abandonner
 *   - une minuterie de sécurité rattrape les vidéos qui ne répondent jamais
 *   - la vidéo s'affiche sur plusieurs signaux, pas seulement `canplay`
 *     (sur iOS avec preload="none", `canplay` peut ne jamais arriver)
 *   - l'appel à play() reste dans le geste de l'utilisateur (sinon iOS bloque)
 */
(function () {
  var LOAD_TIMEOUT_MS = 25000;
  var STYLE_ID = 'kdc-vrc-error-style';

  /* Le message d'erreur est créé par le JS plutôt que dans le fichier .liquid :
     la correction reste contenue dans un seul fichier, et la section (34 Ko,
     partagée avec d'autres réglages) n'a pas besoin d'être touchée. */
  function injectErrorStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.vrc__error{position:absolute;left:50%;bottom:12px;transform:translateX(-50%);' +
      'z-index:6;max-width:88%;margin:0;padding:8px 12px;border-radius:10px;' +
      'background:rgba(17,17,17,.86);color:#ffffff;font-size:13px;line-height:1.35;' +
      'text-align:center;pointer-events:none}' +
      '.vrc__error[hidden]{display:none}' +
      /* En erreur, le bouton play doit rester cliquable pour réessayer. */
      '.vrc__video-shell.is-error .vrc__play-btn{opacity:1;pointer-events:auto}' +
      '.vrc__video-shell.is-error .vrc__tap-hint{opacity:0}';
    document.head.appendChild(style);
  }

  function ensureErrorBox(shell) {
    var box = shell.querySelector('[data-vrc-error]');
    if (box) return box;
    box = document.createElement('p');
    box.className = 'vrc__error';
    box.setAttribute('data-vrc-error', '');
    box.setAttribute('role', 'status');
    box.hidden = true;
    shell.appendChild(box);
    return box;
  }

  function initVrc(root) {
    if (!root || root.dataset.vrcBound === 'true') return;
    root.dataset.vrcBound = 'true';
    injectErrorStyles();

    var lang = root.dataset.lang === 'en' ? 'en' : 'fr';
    var MSG = {
      fr: {
        unsupported: 'Cette vidéo ne peut pas être lue sur cet appareil.',
        network: 'La vidéo n’a pas pu être chargée. Vérifiez votre connexion.',
        blocked: 'Touchez le bouton de lecture pour démarrer la vidéo.'
      },
      en: {
        unsupported: 'This video cannot be played on this device.',
        network: 'The video could not be loaded. Check your connection.',
        blocked: 'Tap the play button to start the video.'
      }
    }[lang];

    var viewport = root.querySelector('[data-vrc-viewport]');
    var track = root.querySelector('[data-vrc-track]');
    var prevBtn = root.querySelector('[data-vrc-prev]');
    var nextBtn = root.querySelector('[data-vrc-next]');
    var slides = root.querySelectorAll('.vrc__slide');

    /* ---------- Défilement du carrousel ---------- */
    if (viewport && track && slides.length > 1) {
      var getScrollStep = function () {
        var firstSlide = slides[0];
        if (!firstSlide) return viewport.clientWidth * 0.85;
        var trackStyles = window.getComputedStyle(track);
        var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
        return firstSlide.getBoundingClientRect().width + gap;
      };

      var updateArrows = function () {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        var x = viewport.scrollLeft;
        prevBtn.disabled = x <= 2;
        nextBtn.disabled = x >= maxScroll - 2;
      };

      var scrollByStep = function (dir) {
        viewport.scrollBy({ left: dir * getScrollStep(), behavior: 'smooth' });
      };

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByStep(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByStep(1); });

      var raf = null;
      viewport.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateArrows);
      }, { passive: true });

      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    /* ---------- Lecture vidéo ---------- */
    var shells = root.querySelectorAll('[data-video-shell]');

    function pauseOtherVideos(exceptVideo) {
      shells.forEach(function (shell) {
        var v = shell.querySelector('[data-review-video]');
        if (!v || v === exceptVideo) return;
        if (!v.paused) v.pause();
      });
    }

    function syncVideoState(shell, video) {
      if (!shell || !video) return;
      shell.classList.toggle('is-playing', !(video.paused || video.ended));
    }

    function animatePlayButton(btn) {
      if (!btn) return;
      btn.classList.remove('is-rotating');
      void btn.offsetWidth;
      btn.classList.add('is-rotating');
      window.setTimeout(function () { btn.classList.remove('is-rotating'); }, 340);
    }

    shells.forEach(function (shell) {
      var video = shell.querySelector('[data-review-video]');
      var playBtn = shell.querySelector('[data-play-btn]');
      var tapHint = shell.querySelector('[data-tap-hint]');
      var posterFallback = shell.querySelector('[data-poster-fallback]');
      var watchdog = null;

      if (!video) return;

      var errorBox = ensureErrorBox(shell);

      /* iOS 9 et antérieurs ignorent `playsinline` et n'acceptent que la forme
         préfixée : sans elle, la vidéo part en plein écran au lieu de jouer
         dans le carrousel. */
      video.setAttribute('webkit-playsinline', '');

      function clearWatchdog() {
        if (watchdog) { window.clearTimeout(watchdog); watchdog = null; }
      }

      /* Préchargement au dernier moment utile.
       *
       * La vidéo reste en preload="none" : au chargement de la page, RIEN n'est
       * téléchargé. C'est la priorité — le site doit rester rapide.
       *
       * On ne réchauffe qu'au moment où l'utilisateur montre son intention :
       * le doigt qui se pose (touchstart) ou la souris qui arrive (pointerenter).
       * Ces deux évènements précèdent le clic de 100 à 300 ms, ce qui suffit à
       * récupérer l'en-tête du fichier. Aucun coût si personne n'interagit.
       */
      var warmed = false;
      function warmUp() {
        if (warmed) return;
        warmed = true;
        try { video.preload = 'metadata'; video.load(); } catch (e) {}
      }

      /* La vidéo devient visible. Appelé sur plusieurs signaux : sur iOS avec
         preload="none", `canplay` peut ne jamais se déclencher. */
      function revealVideo() {
        clearWatchdog();
        shell.classList.remove('is-error');
        video.classList.add('is-ready');
        if (errorBox) errorBox.hidden = true;
        if (posterFallback) posterFallback.classList.remove('is-visible');
      }

      /* Une panne doit se VOIR : on remet l'image de couverture, on rend le
         bouton play, et on affiche pourquoi. Plus jamais de case noire muette. */
      function showFailure(kind) {
        clearWatchdog();
        video.classList.remove('is-ready');
        shell.classList.remove('is-playing');
        shell.classList.add('is-error');
        if (posterFallback) posterFallback.classList.add('is-visible');
        if (errorBox) {
          errorBox.textContent = MSG[kind] || MSG.unsupported;
          errorBox.hidden = false;
        }
      }

      /* Le navigateur a refusé la lecture (politique de lecture automatique,
         mode économie d'énergie iOS), ou rien n'est arrivé dans le délai. La
         vidéo est bonne — on donne à l'utilisateur le lecteur natif du téléphone
         pour qu'il la démarre lui-même. */
      function fallbackToNativeControls() {
        clearWatchdog();
        video.controls = true;
        revealVideo();
        if (errorBox) {
          errorBox.textContent = MSG.blocked;
          errorBox.hidden = false;
        }
      }

      function playVideo() {
        warmUp();
        pauseOtherVideos(video);
        if (playBtn) animatePlayButton(playBtn);
        if (errorBox) errorBox.hidden = true;
        shell.classList.remove('is-error');

        /* Filet de sécurité : si dans 25 s la vidéo n'a toujours pas de données
           lisibles, aucune erreur signalée et la lecture est retombée, on rend
           le lecteur natif plutôt qu'un message sans issue. */
        clearWatchdog();
        watchdog = window.setTimeout(function () {
          if (video.readyState < 2 && video.paused) fallbackToNativeControls();
        }, LOAD_TIMEOUT_MS);

        /* play() est appelé directement dans le geste utilisateur : aucun await
           avant, sinon iOS considère que le geste est perdu et bloque. */
        var p = video.play();
        if (p && typeof p.then === 'function') {
          /* `playing` fait l'affichage ; ici on ne traite que les refus. */
          p.catch(function (err) {
            var name = err && err.name;
            if (name === 'NotAllowedError') {
              fallbackToNativeControls();
            } else if (name === 'NotSupportedError') {
              showFailure('unsupported');
            } else if (name === 'AbortError') {
              /* play() interrompu par un load() ou un pause() : pas une panne. */
            } else {
              showFailure('network');
            }
          });
        }
      }

      function toggleVideo() {
        if (video.paused || video.ended) playVideo();
        else video.pause();
      }

      /* L'intention d'abord, le clic ensuite. */
      shell.addEventListener('touchstart', warmUp, { passive: true });
      shell.addEventListener('pointerenter', warmUp, { passive: true });

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          playVideo();
        });
      }

      video.addEventListener('click', function (e) {
        /* Si le lecteur natif est affiché, on le laisse faire son travail. */
        if (video.controls) return;
        e.preventDefault();
        toggleVideo();
      });

      /* L'image de couverture ne cède la place QUE lorsque la vidéo joue vraiment.
       *
       * Avant, l'affichage se déclenchait aussi sur `loadedmetadata` / `canplay`.
       * Combiné au préchargement à l'intention, un simple survol de la souris ou
       * un doigt qui effleure suffisait à faire disparaître le poster et à
       * laisser un rectangle noir. C'est ce qui cassait les images de couverture. */
      video.addEventListener('playing', revealVideo);

      /* L'élément <video> signale une panne : ici, TOUTES les sources ont été
         essayées. 4 = MEDIA_ERR_SRC_NOT_SUPPORTED (codec ou format refusé par
         l'appareil), le reste est réseau ou décodage. */
      video.addEventListener('error', function () {
        var code = video.error && video.error.code;
        showFailure(code === 4 ? 'unsupported' : 'network');
      });

      /* Volontairement AUCUN écouteur sur les <source> ni sur `stalled` :
         une <source> refusée (le m3u8 hors Safari) est normale, le navigateur
         passe à la suivante ; `stalled` n'est qu'une pause de tampon. */

      video.addEventListener('play', function () {
        syncVideoState(shell, video);
        if (tapHint) tapHint.style.opacity = '0';
      });

      video.addEventListener('pause', function () {
        clearWatchdog();
        syncVideoState(shell, video);
      });

      video.addEventListener('ended', function () {
        clearWatchdog();
        syncVideoState(shell, video);
        try { video.currentTime = 0; } catch (e) {}
      });

      /* Mettre en pause une vidéo sortie de l'écran. */
      if ('IntersectionObserver' in window && viewport) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && !video.paused) video.pause();
          });
        }, { root: viewport, threshold: 0.35 });

        io.observe(shell);
      }

      syncVideoState(shell, video);
    });
  }

  function vrcBoot() {
    document.querySelectorAll('[id^="vrc-"]').forEach(initVrc);
  }

  vrcBoot();
  document.addEventListener('shopify:section:load', vrcBoot);
})();
